class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.onMegaMenuEnter = this.onMegaMenuEnter.bind(this);
    this.onMegaMenuLeave = this.onMegaMenuLeave.bind(this);
    this._megaMenuMqListener = () => this._syncMegaMenuHoverListeners();
  }

  connectedCallback() {
    if (!this.mainDetailsToggle?.classList.contains('mega-menu')) return;
    if (this._megaMenuHoverSetup) return;
    this._megaMenuHoverSetup = true;
    this._hoverDesktopMq = window.matchMedia('(min-width: 990px) and (hover: hover)');
    this._hoverDesktopMq.addEventListener('change', this._megaMenuMqListener);
    this._syncMegaMenuHoverListeners();
  }

  disconnectedCallback() {
    if (!this._megaMenuHoverSetup) return;
    this._megaMenuHoverSetup = false;
    this.removeEventListener('mouseenter', this.onMegaMenuEnter);
    this.removeEventListener('mouseleave', this.onMegaMenuLeave);
    if (this._hoverDesktopMq) {
      this._hoverDesktopMq.removeEventListener('change', this._megaMenuMqListener);
    }
  }

  _syncMegaMenuHoverListeners() {
    if (!this._hoverDesktopMq) return;
    if (this._hoverDesktopMq.matches) {
      this.addEventListener('mouseenter', this.onMegaMenuEnter);
      this.addEventListener('mouseleave', this.onMegaMenuLeave);
    } else {
      this.removeEventListener('mouseenter', this.onMegaMenuEnter);
      this.removeEventListener('mouseleave', this.onMegaMenuLeave);
    }
  }

  onMegaMenuEnter() {
    document.querySelectorAll('.mega-menu[open]').forEach((details) => {
      if (details !== this.mainDetailsToggle) {
        details.open = false;
        const summary = details.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', 'false');
      }
    });
    this.mainDetailsToggle.open = true;
    const summary = this.mainDetailsToggle.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'true');
  }

  onMegaMenuLeave() {
    this.close();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
